export default __webpack_public_path__ + "static/media/pipes.bbef4f27.png";